import { Section, H2, P, Bullets, Figure } from "./Primitives";

const Module = ({ n, title, lead, items, testId }) => (
  <div data-testid={testId} className="module avoid-break">
    <div className="flex items-baseline gap-3 mb-3">
      <span className="font-display text-gold text-xl">{n}</span>
      <h3 className="font-display text-2xl text-navy">{title}</h3>
    </div>
    <P className="!mb-3 text-[var(--ink-soft)]">{lead}</P>
    <Bullets items={items} />
  </div>
);

const Network = () => {
  const nodes = Array.from({ length: 7 }, (_, i) => {
    const a = (Math.PI * 2 * i) / 7 - Math.PI / 2;
    return { x: 300 + Math.cos(a) * 170, y: 190 + Math.sin(a) * 140, label: `PV ${i + 1}` };
  });
  return (
    <svg viewBox="0 0 600 380" className="w-full h-auto chart" data-testid="network-diagram">
      {nodes.map((n) => <line key={n.label} x1="300" y1="190" x2={n.x} y2={n.y} stroke="#B08D57" strokeWidth="1" strokeDasharray="4 4" />)}
      <circle cx="300" cy="190" r="62" fill="#14213D" />
      <circle cx="300" cy="190" r="70" fill="none" stroke="#B08D57" strokeWidth="1" />
      <text x="300" y="184" textAnchor="middle" fill="#F7F1E6" fontSize="18" fontFamily="Bodoni Moda, serif">Synapse OS</text>
      <text x="300" y="204" textAnchor="middle" fill="#D9C29A" fontSize="10" letterSpacing="2">CERVELLO DIGITALE</text>
      {nodes.map((n) => (
        <g key={n.label}>
          <circle cx={n.x} cy={n.y} r="26" fill="#F7F1E6" stroke="#14213D" strokeWidth="1.2" />
          <text x={n.x} y={n.y + 4} textAnchor="middle" fontSize="11" fill="#14213D" fontWeight="600">{n.label}</text>
        </g>
      ))}
      <text x="20" y="360" fontSize="10" fill="#6B6B6B">Laboratorio centrale · Cassa · Magazzino · App Clienti · Portale B2B: un unico archivio dati</text>
    </svg>
  );
};

export const Infrastructure = () => (
  <Section id="infrastruttura" num="02" kicker="Infrastruttura Tecnologica" title="L'ecosistema Synapse OS">
    <P>
      Synapse OS non è un software da costruire da zero ma una piattaforma pronta, che viene <strong>configurata sui processi di Bella Napoli</strong>.
      I sette punti vendita, il laboratorio e i canali di vendita condividono un unico archivio di dati.
      La direzione legge in un solo cruscotto ciò che oggi richiede telefonate, fogli di calcolo e riconciliazioni a fine mese.
    </P>
    <Figure caption="Figura 1 — I 7 punti vendita collegati al sistema centrale.">
      <Network />
    </Figure>
    <H2>I tre moduli e il loro impatto sul conto economico</H2>
    <Module
      testId="module-erp" n="I" title="Gestione centralizzata laboratori e punti vendita"
      lead="Il controllo di gestione dell'intero gruppo, in tempo reale."
      items={[
        <><strong>Produzione su misura della domanda</strong>: il laboratorio produce sulla base dello storico di vendita di ogni sede, giorno per giorno. Ne derivano meno invenduto e meno sprechi di materie prime.</>,
        <><strong>Scorte e trasferimenti tra sedi</strong> visibili da un'unica schermata, con riordino guidato ai fornitori.</>,
        <><strong>Margine per prodotto e per punto vendita</strong>: la Proprietà sa quali referenze e quali sedi generano valore.</>,
        <><strong>Amministrazione snella</strong>: incassi, chiusure di cassa e reportistica consolidati in automatico, senza doppie registrazioni.</>,
      ]}
    />
    <Module
      testId="module-app" n="II" title="App Clienti (B2C): web e telefono"
      lead="Il rapporto diretto con il cliente finale, senza intermediari."
      items={[
        <><strong>Prenotazione e ritiro in negozio</strong> di torte, vassoi e ricorrenze: meno code al banco e produzione programmata.</>,
        <><strong>Programma fedeltà unico</strong> valido in tutti i 7 punti vendita: aumenta la frequenza di acquisto.</>,
        <><strong>Comunicazione mirata</strong>: novità, Linea Luxury e ricorrenze (Pasqua, Natale, San Valentino) inviate a chi le ha già acquistate.</>,
        <><strong>App per iOS e Android e versione web</strong>, incluse nel setup.</>,
      ]}
    />
    <Module
      testId="module-b2b" n="III" title="Portale Corporate (B2B)"
      lead="La nuova linea di ricavo ad alto margine: strenne e regalistica aziendale."
      items={[
        <><strong>Configuratore di strenne natalizie</strong>: l'azienda sceglie composizione, packaging personalizzato e quantità.</>,
        <><strong>Preventivo istantaneo</strong>: il prezzo è calcolato all'istante, senza attese né ricontatti, ed è approvabile con un clic.</>,
        <><strong>Ordini ricorrenti</strong> per eventi, omaggi a clienti, welfare aziendale e ricorrenze.</>,
        <><strong>Pianificazione anticipata</strong>: gli ordini B2B entrano subito nel piano di produzione del laboratorio.</>,
      ]}
    />
  </Section>
);
